import React, {useRef, useEffect, useState} from "react";
import {
    Tabs,
    Tab,
    AppBar,
    useMediaQuery,
    BottomNavigation,
    BottomNavigationAction,
    IconButton,
    Fab, Typography
} from "@material-ui/core";
import AppColors from './../colors/AppColors';
import {useHomeStyle} from "../styles/HomeStyles";
import AppIcon from "../views/AppIcon";
import BalanceView from './../views/BalanceView';
import {useTheme} from '@material-ui/core/styles';
import useWindowSize from 'react-use/lib/useWindowSize';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faAward, faMoneyCheck, faLeaf} from '@fortawesome/free-solid-svg-icons'
import MultiplyBTC from "./MultiplyBTC";
import FreeBTC from './FreeBTC';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import {grey, red} from "@material-ui/core/colors";
import {Copyright} from "./Footer";
import {Route, Switch, Redirect} from "react-router-dom";
import Routes from "../constants/Routes";
import {Constants} from '../constants/Constants';
import {RootStateOrAny, useDispatch, useSelector} from "react-redux";
import {useAppIconStyle} from "../styles/AppIconStyle";
import UsersManager from "../managers/UsersManager";
import ProvablyFairDialog from "./ProvablyFairDialog";
import BitcoinDepositDialog from "./BitcoinDepositDialog";
import EarnBTC from "./EarnBTC";
import BitcoinWithdrawalDialog from "./BitcoinWithdrawalDialog";
import Profile from "./Profile";
import axios from "axios";
import EndPoints from "../net/EndPoints";
import Referrals from "./Referrals";
import Transactions from "./Transactions";
import RequestUtils from "../utils/RequestUtils";

export default function Home() {

    const classes = useHomeStyle();
    const [tabValue, setTabValue] = React.useState(0);
    const theme = useTheme();
    const canDisplayTabs = useMediaQuery(theme.breakpoints.up(864));
    const canDisplayIcon = useMediaQuery(theme.breakpoints.up(1020));
    const canDisplayHamburgerIcon = useMediaQuery(theme.breakpoints.down(864));
    const {width} = useWindowSize();
    const [loggedIn, setLoggedIn] = useState(true);
    const depositButtonRef = useRef(null);
    const withdrawalButtonRef = useRef(null);
    const [redirectPath, setRedirectPath] = useState<string>("");
    const appIconClasses = useAppIconStyle();
    const displayProvablyFair = useSelector((state: RootStateOrAny) => state.appReducer[Constants.PROVABLY_FAIR_INIT_DATA] ?? {});
    const [openDepositDialog, setOpenDepositDialog] = useState(false);
    const [openWithdrawalDialog, setOpenWithdrawalDialog] = useState(false);
    const topTabTitles = ["Free BTC", "Multiply BTC", "Earn BTC"];
    const bottomTabTitles = ["FreeBTC", "Multiply", "Earn"];
    const tabPaths = [Routes.FREE_BTC, Routes.MULTIPLY_BTC, Routes.EARN_BTC];
    const [canDisplayTitle, setCanDisplayTitle] = useState(false);
    const [title, setTitle] = useState("Home");

    const dispatch = useDispatch();

    const onProvablyFairDialogClosed = () => {
        dispatch({
            type: Constants.ACTION_DISPLAY_PROVABLY_FAIR_PAGE,
            payload: {
                [Constants.PROVABLY_FAIR_INIT_DATA]: {}
            }
        });
    }

    const listenToKeyboardEvents = () => {
        document.addEventListener('keydown', function (event: KeyboardEvent) {
            if (event.key.toLowerCase() === "arrowright") {
                setTabValue(tabValue => {
                    let newValue = Math.min(tabValue + 1, 2)
                    setRedirectPath(Constants.TopTabAndRoutes[topTabTitles[newValue]] ?? Constants.BottomTabAndRoutes[bottomTabTitles[newValue]]);
                    return newValue;
                });
            } else if (event.key.toLowerCase() === "arrowleft") {
                setTabValue(tabValue => {
                    let newValue = Math.max(tabValue - 1, 0)
                    setRedirectPath(Constants.TopTabAndRoutes[topTabTitles[newValue]] ?? Constants.BottomTabAndRoutes[bottomTabTitles[newValue]]);
                    return newValue;
                });
            }
        });
    }

    useEffect(() => {
        listenToKeyboardEvents();
    }, []);

    const onDepositBitcoinDialogClosed = () => {
        setOpenDepositDialog(false);
    }

    const onWithdrawalDialogClosed = () => {
        setOpenWithdrawalDialog(false);
    }

    const useUnload = (fn: any) => {
        const cb = useRef(fn);
        useEffect(() => {
            cb.current = fn;
        }, [fn]);
        useEffect(() => {
            const onUnload = (...args: any[]) => cb.current?.(...args);
            window.addEventListener("beforeunload", onUnload);
            return () => window.removeEventListener("beforeunload", onUnload);
        }, []);
    };

    useUnload(() => {
        checkAndClearUserData();
    });

    const handleHamBurgerClick = () => {
        window.location.href = Routes.DEFAULT;
    }

    const handleChange = (event: any, newValue: any) => {
        setTitle("");
        setCanDisplayTitle(false);
        if (tabValue !== newValue) {
            setTabValue(newValue);
            setRedirectPath(Constants.TopTabAndRoutes[topTabTitles[newValue]] ?? Constants.BottomTabAndRoutes[bottomTabTitles[newValue]]);
        }
    }

    const checkAndClearUserData = () => {
        let loggedInUserString: any = UsersManager.getLoggedInUserFromSessionStorage();
        if (!loggedInUserString) {
            setLoggedIn(false);
        }
    }

    useEffect(() => {
        const lastIndexOfForwardSlash = window.location.href.toString().lastIndexOf("/");
        const navigatedPath = "/home" + window.location.href.substring(lastIndexOfForwardSlash);
        if (navigatedPath.toLowerCase().includes("profile")) {
            setTitle("Profile");
            setCanDisplayTitle(true);
        } else if (navigatedPath.toLowerCase().includes("transactions")) {
            setTitle("Transactions");
            setCanDisplayTitle(true);
        } else if (navigatedPath.toLowerCase().includes("referrals")) {
            setTitle("Referrals");
            setCanDisplayTitle(true);
        } else {
            setTitle("");
            setCanDisplayTitle(false);
            if (navigatedPath !== redirectPath) {
                if (navigatedPath === "/home/home") {
                    setTabValue(0);
                } else {
                    let indexOfPath = tabPaths.indexOf(navigatedPath);
                    setTabValue(indexOfPath);
                }
            }
        }
        fetchUpdatedUserData();
    }, [window.location.href]);

    const fetchUpdatedUserData = () => {
        axios.get(EndPoints.MY_DATA, {
            headers: RequestUtils.getHeaders()
        }).then(response => {
            let userData = response["data"]["data"]
            if (userData !== undefined) {
                UsersManager.saveLoggedInUser(JSON.stringify(userData));
            }
        }).catch(_error => {

        });
    }

    const depositBTC = () => {
        setOpenDepositDialog(true);
    }

    const withdrawBTC = () => {
        setOpenWithdrawalDialog(true);
    }

    return (
        !UsersManager.getLoggedInUser() || !loggedIn
            ? <Redirect to={Routes.DEFAULT}/>
            :
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                overflowX: 'hidden',
                background: `url(${require('./../images/future_of_investment.png')})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: '#1E2529D7',
                }}>
                    <div>
                        <AppBar title={"Profile"}
                                style={{
                                    backgroundColor: AppColors.PRIMARY_COLOR,
                                    flexDirection: 'row',
                                }}>
                            {
                                canDisplayHamburgerIcon &&
                                <IconButton style={{
                                    alignSelf: 'center',
                                    color: 'white',
                                    margin: 5,
                                }} onClick={handleHamBurgerClick}>
                                    <img src={require('../images/bitcoin_for_all.png')}
                                         className={appIconClasses.appIcon} alt={"Bitcoin For All"}/>

                                </IconButton>
                            }
                            {
                                canDisplayIcon &&
                                <div>
                                    <AppIcon/>
                                </div>
                            }
                            <div style={{
                                flexGrow: 1,
                            }}>
                                {
                                    canDisplayTitle &&
                                    <Typography
                                        onClick={handleHamBurgerClick}
                                        align={"center"}
                                        style={{
                                            color: 'white',
                                            textAlign: 'center',
                                            alignSelf: 'center',
                                            paddingTop: 5,
                                            cursor: 'pointer',
                                            fontSize: 20
                                        }}>{title}</Typography>
                                }
                                {
                                    canDisplayTabs && !canDisplayTitle &&
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                    }}>
                                        <Tabs
                                            value={tabValue}
                                            classes={{
                                                indicator: classes.indicator
                                            }}
                                            textColor="inherit"
                                            onChange={handleChange}
                                            variant="scrollable"
                                            scrollButtons="auto"
                                            aria-label="Window Options">
                                            <Tab label="Free BTC"/>
                                            <Tab label="Multiply BTC"/>
                                            <Tab label="Earn BTC"/>
                                        </Tabs>
                                    </div>
                                }
                            </div>
                            <BalanceView/>
                        </AppBar>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            marginTop: 75,
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <Fab ref={depositButtonRef}
                                 onClick={depositBTC}
                                 variant="extended"
                                 style={{
                                     backgroundColor: AppColors.BLUE,
                                     fontWeight: 600,
                                     color: grey[200],
                                     marginTop: 20,
                                     marginRight: 15,
                                 }}>
                                <AddIcon className={classes.extendedIcon}/>
                                Deposit BTC
                            </Fab>
                            <Fab ref={withdrawalButtonRef}
                                 onClick={withdrawBTC}
                                 variant="extended"
                                 style={{
                                     backgroundColor: red[800],
                                     fontWeight: 600,
                                     color: grey[200],
                                     marginTop: 20,
                                 }}>
                                <RemoveIcon className={classes.extendedIcon}/>
                                WITHDRAW BTC
                            </Fab>
                        </div>
                        {
                            !canDisplayTitle &&
                            <div style={{paddingBottom: 100}}>
                                <Switch>
                                    <Route path={Routes.MULTIPLY_BTC} component={MultiplyBTC}/>
                                    <Route path={Routes.FREE_BTC} component={FreeBTC}/>
                                    <Route path={Routes.EARN_BTC} component={EarnBTC}/>
                                    <Route component={FreeBTC}/>
                                </Switch>
                            </div>
                        }
                        {
                            canDisplayTitle && title.toLowerCase().includes("profile") &&
                            <Profile/>
                        }
                        {
                            canDisplayTitle && title.toLowerCase().includes("referrals") &&
                            <Referrals/>
                        }
                        {
                            canDisplayTitle && title.toLowerCase().includes("transactions") &&
                            <Transactions/>
                        }
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            padding: 10,
                            backgroundColor: `${AppColors.PRIMARY_COLOR}`,
                            justifyContent: 'center'
                        }}>
                            <Typography style={{
                                color: 'white',
                                fontWeight: 600,
                                fontSize: 16,
                                alignSelf: 'center',
                                border: `6px solid ${red[600]}`,
                                padding: 5,
                                borderRadius: 10
                            }}>18+</Typography>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: 20,
                                backgroundColor: `${AppColors.PRIMARY_COLOR}`
                            }}>
                                <Copyright/>
                            </div>
                        </div>
                    </div>
                    {
                        canDisplayHamburgerIcon &&
                        <BottomNavigation
                            value={tabValue}
                            onChange={handleChange}
                            showLabels
                            style={{
                                position: 'fixed',
                                backgroundColor: AppColors.PRIMARY_COLOR,
                                bottom: 0,
                                zIndex: 1,
                                width: width,
                                boxSizing: 'border-box'
                            }}
                        >
                            <BottomNavigationAction label="FreeBTC"
                                                    icon={<FontAwesomeIcon icon={faAward}
                                                                           style={{width: 25, height: 25}}/>}
                                                    className={classes.bottomNavigationAction}/>
                            <BottomNavigationAction label="Multiply BTC"
                                                    icon={<FontAwesomeIcon icon={faLeaf} style={{
                                                        width: 25,
                                                        height: 25
                                                    }}/>} className={classes.bottomNavigationAction}/>
                            <BottomNavigationAction label="Earn BTC" icon={<FontAwesomeIcon icon={faMoneyCheck} style={{
                                width: 25,
                                height: 25
                            }}/>} className={classes.bottomNavigationAction}/>
                        </BottomNavigation>
                    }
                    {
                        redirectPath &&
                        <Redirect to={redirectPath}/>
                    }
                </div>
                <ProvablyFairDialog open={displayProvablyFair[Constants.OPEN]}
                                    scrollToHow={displayProvablyFair[Constants.SCROLL_TO_HOW]}
                                    gameType={displayProvablyFair[Constants.ACTION_ORIGINATOR]}
                                    onDialogClosed={onProvablyFairDialogClosed}/>

                <BitcoinDepositDialog open={openDepositDialog} onDialogClosed={onDepositBitcoinDialogClosed}/>
                <BitcoinWithdrawalDialog open={openWithdrawalDialog} onDialogClosed={onWithdrawalDialogClosed}/>
            </div>
    );
}